var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTalent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 5763",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 10",
    cx: 12,
    cy: 12,
    r: 12,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Subtraction 1",
    d: "M14.589 18.06H4.852A.845.845 0 014 17.204V3.856a.855.855 0 01.852-.854h9.737a.855.855 0 01.844.854V17.2a.851.851 0 01-.844.86zm-7.392-7.059a1 1 0 100 2h2a1 1 0 100-2zm0-3a1 1 0 100 2h5a1 1 0 100-2zm0-3a1 1 0 000 2h5a1 1 0 000-2z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11",
    d: "M6.455 18.7h9.477a.4.4 0 00.4-.4V6.044a.395.395 0 01.789 0V18.3a1.193 1.193 0 01-1.192 1.192H6.455a.395.395 0 110-.789z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12",
    d: "M7.143 20.145h10.162a.425.425 0 00.432-.423V6.583a.423.423 0 01.846 0v13.139A1.279 1.279 0 0117.305 21H7.143a.427.427 0 110-.855z"
  })))));
}
export default SvgTalent;